import React from 'react';

// The app's icon set: Material Symbols Rounded, loaded from public/index.html
// and styled by the base rule in styles/global.css.
//
// `name` is the symbol's ligature name ("add", "chevron_right"), not a class.
// There is deliberately no Font Awesome translation table: call sites and the
// icon names stored in config/appVariant.js were changed to Material names in
// the same pass, so a shim would have outlived its reason on day one.
//
// Icons are decorative by default — each sits beside its own text, or inside a
// control that already carries an aria-label — so they are hidden from
// assistive tech. Pass `label` for the rare icon that is the only content.
// `spin` is for the one symbol that stands in for M3's circular progress
// indicator (`progress_activity`). It lives here rather than as a copy of the
// same keyframes in every stylesheet that needs a busy state.
//
// It renders <i>, not <span>, on purpose. Sixteen stylesheets size and colour
// these icons through selectors like `.newChatBtn i` written when the app used
// Font Awesome; keeping the element means every one of them still applies and
// none had to be rewritten. The base rule in global.css sets font-style
// normal, so the browser's default italic on <i> never reaches the glyph.
//
// There is no `fill` prop. The shipped font pins FILL, wght, GRAD and opsz —
// nothing in the app varies them, and pinning is what takes the subset from
// 229KB to 18KB. Restoring a filled variant means widening the axis in the
// font request too, not just adding a prop here.
const Icon = ({ name, className, label, spin = false, style }) => (
  <i
    className={`material-symbols-rounded${spin ? ' icon-spin' : ''}${className ? ` ${className}` : ''}`}
    style={style}
    aria-hidden={label ? undefined : 'true'}
    role={label ? 'img' : undefined}
    aria-label={label}
  >
    {name}
  </i>
);

export default Icon;
